import useBreadcrumbs from '@admin/hooks/useAdminBreadcrumbs';
import PageHeader from '@shared/components/core/headers/PageHeader';
import SubSectionRow from '@shared/components/core/headers/SubSectionRow';
import NoAssociatedOrgBanner from '@shared/components/organization/banners/NoAssociatedOrgBanner';
import NoEmailVerifiedBanner from '@shared/components/organization/banners/NoEmailVerifiedBanner';
import OrgActionRow from '@shared/components/organization/OrgActionRow';
import CurrentUserContainer from '@shared/hooks/state/CurrentUserContainer';
import OrganizationContainer from '@shared/hooks/state/OrganizationContainer';
import { useTranslation } from 'react-i18next';

export default function DashboardPage() {
    const { t } = useTranslation();
    const { items } = useBreadcrumbs();
    const { memberships } = OrganizationContainer.useContainer();
    const { currentUser } = CurrentUserContainer.useContainer();

    // part of multiple orgs or single org with multiple members
    const canViewOrganizationDetails =
        memberships.length > 1 || (memberships.length === 1 && (memberships[0].organization.maxMembers ?? 0) > 1);

    return (
        <>
            <PageHeader title={t('common:welcome')} items={items} />
            <NoEmailVerifiedBanner />
            <NoAssociatedOrgBanner />
            {memberships?.length > 0 && currentUser?.isEmailVerified && (
                <SubSectionRow
                    title={
                        canViewOrganizationDetails
                            ? t('common:organization.titlePlural')
                            : t('common:license.titlePlural')
                    }
                    description={
                        canViewOrganizationDetails
                            ? t('common:organization.description')
                            : t('common:billing.description')
                    }
                />
            )}
            {memberships &&
                currentUser?.isEmailVerified &&
                memberships.map((membership) => (
                    <OrgActionRow key={membership.organizationId} membership={membership} />
                ))}
        </>
    );
}
